module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('mu-card-header', {
    attrs: {
      "titleClass": "largeTitle boldTitle",
      "title": _vm.title,
      "subTitle": _vm.subTitle
    }
  }, [_c('mu-icon-button', {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      "slot": "avatar",
      "icon": "chevron_left"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm()
      }
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "100",
      "desktop": "80",
      "tablet": "100"
    }
  }, [(_vm.user.diabetes_type.is_diabetic) ? _c('div', [_c('div', {
    staticClass: "mu-text-field-label"
  }, [_vm._v(_vm._s(_vm.$t('message.labelITakeThisForMy')) + " " + _vm._s(_vm.user.diabetes_type.diabetes_type))]), _vm._v(" "), _c('mu-radio', {
    staticClass: "demo-radio",
    attrs: {
      "label": _vm.$t('message.labelYes'),
      "name": "group",
      "nativeValue": 1
    },
    model: {
      value: (_vm.model.forDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.model, "forDiabetes", $$v)
      },
      expression: "model.forDiabetes"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-radio', {
    staticClass: "demo-radio",
    attrs: {
      "label": _vm.$t('message.labelNo'),
      "name": "group",
      "nativeValue": 0
    },
    model: {
      value: (_vm.model.forDiabetes),
      callback: function($$v) {
        _vm.$set(_vm.model, "forDiabetes", $$v)
      },
      expression: "model.forDiabetes"
    }
  }), _vm._v(" "), _c('br')], 1) : _vm._e(), _vm._v(" "), _c('mu-auto-complete', {
    attrs: {
      "scroller": _vm.scroller,
      "maxHeight": 250,
      "inputClass": _vm.medicationInputClass,
      "inputClass": "mediSearchInput",
      "openOnFocus": true,
      "dataSource": _vm.medicationDataSource,
      "dataSourceConfig": _vm.medicationDataSourceConfig,
      "fullWidth": true,
      "maxSearchResults": 10,
      "hintText": "Start typing for suggestions",
      "filter": "noFilter",
      "fullWidth": "",
      "label": _vm.$t('message.labelMedicationName')
    },
    on: {
      "change": _vm.handleMedicationSelected
    },
    model: {
      value: (_vm.medicationSearchValue),
      callback: function($$v) {
        _vm.medicationSearchValue = $$v
      },
      expression: "medicationSearchValue"
    }
  }), _vm._v(" "), (_vm.model.forDiabetes === 0 && _vm.user.diabetes_type.is_diabetic || _vm.model.forDiabetes === 0 && _vm.user.diabetes_type.is_diabetic === false) ? _c('mu-row', [(_vm.conditions.length > 0) ? _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "condition",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('condition'),
      "hintText": _vm.$t('message.searchText'),
      "label": _vm.$t('message.labelWhatDoYouTakeItFor'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.condition_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "condition_id", $$v)
      },
      expression: "model.condition_id"
    }
  }, _vm._l((_vm.conditions), function(item) {
    return _c('mu-menu-item', {
      key: 'condition-' + item.condition_id,
      attrs: {
        "title": item.condition_label,
        "value": item.condition_id
      }
    })
  }), 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "dosage",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('dosage'),
      "min": "0",
      "type": "number",
      "label": _vm.$t('message.labelDosage'),
      "hintText": _vm.$t('message.placeholderText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.defaultDosage),
      callback: function($$v) {
        _vm.$set(_vm.model, "defaultDosage", _vm._n($$v))
      },
      expression: "model.defaultDosage"
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "width": "50",
      "tablet": "50",
      "desktop": "50"
    }
  }, [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "units",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('units'),
      "maxHeight": 250,
      "scroller": _vm.scroller,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.labelUnits'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.unit_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "unit_id", $$v)
      },
      expression: "model.unit_id"
    }
  }, _vm._l((_vm.regimes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'regime-' + index,
      attrs: {
        "value": item.ID,
        "title": item.regimeUnitLabel
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "data-vv-value-path": "inputValue",
      "data-vv-name": "frequency",
      "data-vv-validate-on": "none",
      "errorText": _vm.errors.first('frequency'),
      "maxHeight": 250,
      "scroller": _vm.scroller,
      "hintText": _vm.$t('message.selectText'),
      "label": _vm.$t('message.labelHowOften'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.frequency_id),
      callback: function($$v) {
        _vm.$set(_vm.model, "frequency_id", $$v)
      },
      expression: "model.frequency_id"
    }
  }, _vm._l((_vm.frequencies), function(item, index) {
    return _c('mu-menu-item', {
      key: 'frequency-' + index,
      attrs: {
        "value": item.ID,
        "title": item.frequency
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "large",
    attrs: {
      "disabled": _vm.isSaving,
      "type": "button",
      "fullWidth": "",
      "label": !_vm.isSaving ? _vm.$t('message.saveText') : _vm.$t('message.savingText'),
      "secondary": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  })], 1), _vm._v(" "), (_vm.isError) ? _c('div', {
    staticClass: "isError",
    staticStyle: {
      "margin-top": "16px"
    },
    domProps: {
      "textContent": _vm._s(_vm.errorMessage)
    }
  }) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11884076","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Settings/Medicatations/Add.vue
// module id = 3053
// module chunks = 1